import React from "react";
import {ChatHistoryDTO, MessageType, WidgetAppearanceLocaleVariantUi} from "../../../../../../../api/generated";
import {AssistantTextMessage} from "./textMessage/AssistantTextMessage";
import {AssistantVideoMessage} from "./videoMessage/AssistantVideoMessage";
import {AssistantGalleryMessage} from "./galleryMessage/AssistantGalleryMessage";

interface AssistantMessageProps {
    chatHistory: ChatHistoryDTO
    widgetAppearanceSettings: WidgetAppearanceLocaleVariantUi
}

export const AssistantMessage: React.FC<AssistantMessageProps> = ({
                                                                      chatHistory,
                                                                      widgetAppearanceSettings
                                                                  }) => {

    const index = chatHistory.id

    switch (chatHistory.messageType) {
        case MessageType.Text:
            return <AssistantTextMessage
                key={`assistant-text-${index}`}
                chatHistory={chatHistory}
                widgetAppearanceSettings={widgetAppearanceSettings}
            />
        case MessageType.Video:
            return <AssistantVideoMessage
                key={`assistant-video-${index}`}
                chatHistory={chatHistory}
                widgetAppearanceSettings={widgetAppearanceSettings}
            />
        case MessageType.Gallery:
            return <AssistantGalleryMessage
                key={`assistant-gallery-${index}`}
                chatHistory={chatHistory}
                widgetAppearanceSettings={widgetAppearanceSettings}
            />
        default:
            return <AssistantTextMessage
                key={`assistant-text-${index}`}
                chatHistory={chatHistory}
                widgetAppearanceSettings={widgetAppearanceSettings}
            />
    }
}
